import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

export default function Header() {
  const { t } = useTranslation();

  return (
    <header
      id="site-header"
      className="relative w-full bg-bistro-dark border-b border-bistro-border"
    >
      {/* Subtle marble texture overlay */}
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage: `radial-gradient(ellipse at 20% 50%, rgba(212,168,67,0.05) 0%, transparent 60%),
                            radial-gradient(ellipse at 80% 50%, rgba(212,168,67,0.03) 0%, transparent 60%)`,
        }}
      />

      <div className="relative z-10 px-4 py-5 flex items-start justify-between max-w-2xl mx-auto">
        {/* Left spacer (mirrors lang switcher width for centering) */}
        <div className="w-24 sm:w-32 flex-shrink-0" />

        {/* Center: Logo + Slogan */}
        <div className="flex-1 flex flex-col items-center text-center px-2">
          {/* Decorative top line */}
          <div className="flex items-center gap-2 mb-3 w-full justify-center">
            <div className="h-px flex-1 max-w-16 bg-gradient-to-r from-transparent to-bistro-gold opacity-60" />
            <span className="text-bistro-gold text-xs tracking-[0.3em] uppercase font-sans font-medium opacity-80">
              ✦ Est. 2026 ✦
            </span>
            <div className="h-px flex-1 max-w-16 bg-gradient-to-l from-transparent to-bistro-gold opacity-60" />
          </div>

          {/* Main Logo */}
          <h1
            className="font-serif font-bold tracking-wide leading-none"
            style={{
              fontSize: 'clamp(1.6rem, 7vw, 2.4rem)',
              background: 'linear-gradient(135deg, #B8860B 0%, #D4A843 35%, #E8B84B 60%, #D4A843 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              filter: 'drop-shadow(0 2px 8px rgba(212,168,67,0.3))',
            }}
          >
            Istanbul Bistro
          </h1>

          {/* Slogan */}
          <p
            className="mt-1.5 text-bistro-muted font-sans font-light italic tracking-wider"
            style={{ fontSize: 'clamp(0.65rem, 3vw, 0.8rem)', letterSpacing: '0.1em' }}
          >
            {t('app.slogan')}
          </p>

          {/* Decorative bottom divider */}
          <div className="mt-3 flex items-center gap-1.5">
            <div className="h-px w-12 bg-bistro-gold opacity-30" />
            <span className="text-bistro-gold opacity-50 text-xs">◆</span>
            <div className="h-px w-12 bg-bistro-gold opacity-30" />
          </div>
        </div>

        {/* Right: Language Switcher */}
        <div className="w-24 sm:w-32 flex-shrink-0 flex justify-end pt-1">
          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
}
